import { Builder } from '@builder.io/react';

import DataSlider from './index';

Builder.registerComponent(DataSlider, {
  name: 'DataSlider',
  inputs: [
    {
      name: 'hash',
      type: 'string'
    },
    {
      name: 'overtitle',
      type: 'string'
    },
    {
      name: 'title',
      type: 'string'
    },
    {
      name: 'description',
      type: 'string'
    },
    {
      name: 'bleeds',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'inverted',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'cta',
      type: 'object',
      subFields: [
        {
          name: 'buttons',
          type: 'list',
          defaultValue: [
            {
              text: 'Get Started',
              href: '/sales',
              variant: 'primary'
            }
          ],
          subFields: [
            {
              name: 'text',
              type: 'string'
            },
            {
              name: 'href',
              type: 'url'
            },
            {
              name: 'variant',
              type: 'string',
              defaultValue: 'primary',
              enum: ['primary', 'secondary', 'inverted']
            }
          ]
        },
        {
          name: 'hubspotModal',
          type: 'boolean',
          defaultValue: false
        },
        {
          name: 'hubspotModal',
          type: 'object',
          subFields: [
            {
              name: 'formId',
              type: 'string'
            },
            {
              name: 'sfdcCampaignId',
              type: 'string'
            },
            {
              name: 'label',
              type: 'string'
            }
          ]
        }
      ]
    },
    {
      name: 'images',
      type: 'list',
      subFields: [
        {
          name: 'src',
          type: 'file',
          allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'],
          defaultValue: 'https://cdn.builder.io/api/v1/image/assets%2Fe0438815ba51486bbb6a202747122d4b%2F8eac1a4bb08044fbaf98b047fcd07dd1',
        },
        {
          name: 'epigraph',
          type: 'string',
          defaultValue: 'Epigraph'
        },
        {
          name: 'width',
          type: 'number'
        },
        {
          name: 'height',
          type: 'number'
        },
        {
          name: 'alt',
          type: 'string'
        },
      ],
      defaultValue: []
    }
  ]
});
